import React from "react";
import { Table } from "@optimizely/axiom";
import { LoadingTable } from "../LoadingIndicator/LoadingTable";
import { SuperAdminOrganization } from "../../../hooks/useSuperAdminOrganizations/useSuperAdminOrganizations";
import { DeveloperSettingsByOrg } from "../../../hooks/useDeveloperSettingsSearch/useDeveloperSettingsSearch";
import { DeveloperSettingsTableRow } from "./DeveloperSettingsTableRow";

type DeveloperSettingsTableProps = {
    organizations?: SuperAdminOrganization[];
    developerSettingsByOrg: DeveloperSettingsByOrg;
    loading?: boolean;
    onUpdate: (payload: { organizationId: string; enabled: boolean; vendorName: string }) => Promise<unknown>;
};

export const DeveloperSettingsTable = ({
    organizations = [],
    developerSettingsByOrg,
    loading,
    onUpdate
}: DeveloperSettingsTableProps) => {
    if (loading) {
        return <LoadingTable headers={["Organization", "Developer Mode", "Vendor Name", ""]} />;
    }

    return (
        <Table
            className="push-double--bottom"
            density="loose"
            // eslint-disable-next-line react/style-prop-object
            style="rule-no-bottom-border"
        >
            <Table.THead>
                <Table.TR>
                    <Table.TH sorting={{ canSort: false }} width="35%">
                        Organization
                    </Table.TH>
                    <Table.TH sorting={{ canSort: false }} width="20%">
                        Developer Mode
                    </Table.TH>
                    <Table.TH sorting={{ canSort: false }} width="30%">
                        Vendor Name
                    </Table.TH>
                    <Table.TH sorting={{ canSort: false }} width="15%"></Table.TH>
                </Table.TR>
            </Table.THead>
            <Table.TBody>
                {organizations?.map((organization: SuperAdminOrganization) => {
                    const developer = developerSettingsByOrg[organization.organizationId];
                    return (
                        <DeveloperSettingsTableRow
                            key={organization.organizationId}
                            organizationId={organization.organizationId}
                            organizationName={organization.organizationName}
                            enabled={developer?.enabled ?? false}
                            vendorName={developer?.vendorName ?? ""}
                            onUpdate={({ enabled, vendorName }) =>
                                onUpdate({ organizationId: organization.organizationId, enabled, vendorName })
                            }
                        />
                    );
                })}
            </Table.TBody>
        </Table>
    );
};

DeveloperSettingsTable.displayName = "DeveloperSettingsTable";
